import React from 'react'
import t from 'prop-types'

import GrupoPortada from './grupo-portada'


function PantallaPortada ({ configPortada, GestorSesiones, onAccion, onMostrarGestorSesiones }) {
    if(configPortada.saltarPantalla){
        handleAccion (configPortada.saltarPantalla)
    }
    
    function handleAccion (accion) {
        onAccion(accion)
    }

    function handleClaqueta () {
        const zonaClaqueta = zonaPresentacion || 'VD001.1'
        onAccion({ zona: zonaClaqueta })
    }

    function handleCreditos () {
            const { zonaCreditos } = configPortada
            onAccion({ zona: zonaCreditos })
    }

    function handleGestorSesiones() {
            onMostrarGestorSesiones && onMostrarGestorSesiones()
    }
    
    function crearDivAdorno(id){
        return <img src={"css/imagenes/menus/adorno" + id + ".png"} className={"adorno" + id} alt="" />
    }

    function BotonPDF(props) {
        if(window.electronContext && window.mostrarPDF){
            // si estamos en electron y existe la función mostrarPDF en index.html
            return <a onClick={() => window.mostrarPDF(props.fichero)} rel="noopener noreferrer" className={ props.clase }>{ props.texto }</a>
        } else if(window.parent.electronContext && window.parent.mostrarPDF){
            // si estamos en electron, index.html está cargado en un i-frame y existe la función mostrarPDF en el fichero de carga
            return <a onClick={() => window.parent.mostrarPDF(props.fichero)} rel="noopener noreferrer" className={ props.clase }>{ props.texto }</a>
        } else if(window.electronContext && !window.mostrarPDF){
            // si estamos en electron y NO existe la función mostrarPDF en index.html
            return <a href={ props.fichero } rel="noopener noreferrer" className={ props.clase }>{ props.texto }</a>
        } else {
            // --> navegador
            return <a href={ props.fichero } target="_blank" rel="noopener noreferrer" className={ props.clase }>{ props.texto }</a>
        }
    }

    const { titulo, nivel, grupos, botonExtra, pdfAyuda, textoAyuda, textoCreditos, pdfLicencia, textoLicencia, adornos, textoPresentacion, zonaPresentacion } = configPortada
    return (
        <div className="fondoMenus">
            <div className="portada">
                { adornos && adornos.map(id => crearDivAdorno(id)) }
                <div className="cabeceraPortada">
                    <div className="logo"></div>
                    <div className="nivel">{ nivel }</div>
                    <div className="titulo">{ titulo }</div>
                </div>
                { grupos.map( (grupo, index) => 
                    <GrupoPortada key={`grupo-${index}`} accesos={ grupo } onAccion={ handleAccion } /> 
                )}
                { textoPresentacion && <div className="grupoPortada" onClick={ handleClaqueta } >
                    { textoPresentacion.split('<br/>').map(i => <React.Fragment>{i}<br/></React.Fragment>) }    
                    <img alt="" src="css/imagenes/comun/claqueta.svg" />
                </div> }
                <div className="botonCreditos" onClick={ handleCreditos } >{ textoCreditos }</div>
                <div className="botonSesiones" onClick={ handleGestorSesiones }></div>
                {/*<div className="botonExtra" onClick={ () => handleAccion({ indice: 'Innovate' })} ></div> --> se puede vincular creando el elemento de menú: { texto: "GO! innovate", indice: "Innovate" }*/}
                { botonExtra && <div className="botonExtra" onClick={ () => handleAccion( botonExtra ) } > { botonExtra.texto ? botonExtra.texto : '' } </div> }

                { /* <a href={ pdfAyuda } target="_blank" rel="noopener noreferrer" className="ayudaPortada">{ textoAyuda }</a> */ }
                { /* <a href={ pdfLicencia } target="_blank" rel="noopener noreferrer" className="botonTextoLegal">{ textoLicencia }</a> */ }
                <BotonPDF fichero={ pdfAyuda } clase="ayudaPortada" texto= { textoAyuda }/>
                <BotonPDF fichero={ pdfLicencia } clase="botonTextoLegal" texto= { textoLicencia }/>

                 <div className="logoSecundario"></div>
                {/* <div className="cerrar boton1estado">Quit</div> */}
            </div>
            { GestorSesiones && <GestorSesiones /> }
        </div>
    )
} 

PantallaPortada.propTypes = {
    configPortada: t.shape({
        titulo: t.string.isRequired,
        nivel: t.string.isRequired,
        grupos: t.arrayOf(
            t.arrayOf(
                t.shape(
                    {
                        texto: t.string.isRequired,
                        indice: t.string,
                        pantalla: t.string,
                        zona: t.string
                    }
                )
            )
        ).isRequired
    }),
    GestorSesiones: t.any,
    onAccion: t.func.isRequired,
    onMostrarGestorSesiones: t.func.isRequired
}
export default PantallaPortada